import { render } from "./Configs.vue?vue&type=template&id=6cec2a2c&scoped=true"
import script from "./Configs.vue?vue&type=script&lang=js"
export * from "./Configs.vue?vue&type=script&lang=js"

import "./Configs.vue?vue&type=style&index=0&id=6cec2a2c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cec2a2c"]])

export default __exports__